// Mock data for The Majordhome Conciergerie

export const services = [
  {
    id: 'menage',
    title: 'Ménage',
    description: 'Entretien complet et régulier de votre domicile avec des produits professionnels',
    icon: 'Home',
    color: 'from-[#153254] to-[#122b26]',
    image: 'https://images.unsplash.com/photo-1686178827149-6d55c72d81df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxjbGVhbmluZyUyMHNlcnZpY2V8ZW58MHx8fHwxNzY3Mjg4MzY0fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'jardinage',
    title: 'Jardinage',
    description: 'Entretien professionnel de vos espaces verts et aménagements paysagers',
    icon: 'TreePine',
    color: 'from-[#122b26] to-[#153254]',
    image: 'https://images.pexels.com/photos/7728868/pexels-photo-7728868.jpeg'
  },
  {
    id: 'bricolage',
    title: 'Bricolage',
    description: 'Petits travaux de réparation et aménagements intérieurs',
    icon: 'Wrench',
    color: 'from-[#153254] to-[#122b26]',
    image: 'https://images.unsplash.com/photo-1633759593085-1eaeb724fc88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHw0fHxoYW5keW1hbiUyMHJlcGFpcnxlbnwwfHx8fDE3NjczMDM4OTB8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'demenagement',
    title: 'Aide au déménagement',
    description: 'Accompagnement complet pour votre déménagement en toute sérénité',
    icon: 'Truck',
    color: 'from-[#153254] to-[#122b26]',
    image: 'https://images.unsplash.com/photo-1600518464441-9154a4dea21b?w=800&q=80'
  },
  {
    id: 'administratif',
    title: 'Aide administrative',
    description: 'Assistance personnalisée dans vos démarches administratives',
    icon: 'FileText',
    color: 'from-[#122b26] to-[#153254]',
    image: 'https://images.pexels.com/photos/3768146/pexels-photo-3768146.jpeg'
  },
  {
    id: 'vehicule',
    title: 'Nettoyage de véhicule',
    description: 'Nettoyage complet intérieur et extérieur de votre véhicule',
    icon: 'Car',
    color: 'from-[#153254] to-[#122b26]',
    image: 'https://images.unsplash.com/photo-1607860108855-64acf2078ed9?w=800&q=80'
  },
  {
    id: 'airbnb',
    title: 'Gestion Airbnb',
    description: 'Gestion complète de votre logement Airbnb : annonce, réservations, communication voyageurs, ménage, linge et suivi des prestations',
    icon: 'Building',
    color: 'from-[#122b26] to-[#153254]',
    image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Guillaume',
    rating: 5,
    date: 'Octobre 2025',
    timeAgo: 'Il y a 2 mois',
    comment: 'Nous avons fait appel à The MajordHome Conciergerie (Méru) pour l\'élagage de notre haie, et nous sommes très satisfaits. Travail soigné, équipe ponctuelle et à l\'écoute. En plus, les explications sur le crédit d\'impôt étaient claires et précises. Je recommande vivement !',
    source: 'Google',
    avatar: 'https://customer-assets.emergentagent.com/job_concierge-website/artifacts/c81q4h9h_guillaume.png'
  },
  {
    id: 2,
    name: 'Marie Odile Coq',
    rating: 5,
    date: 'Octobre 2025',
    timeAgo: 'Il y a 2 mois',
    comment: 'J\'ai fait appel à eux ce week-end pour la première fois pour l\'entretien de mes haies. Très satisfaite. Je recommande sans hésiter.',
    source: 'Google',
    avatar: 'https://customer-assets.emergentagent.com/job_concierge-website/artifacts/pwd318d3_marie%20odil.png'
  },
  {
    id: 3,
    name: 'Mata Rody',
    rating: 5,
    date: 'Août 2025',
    timeAgo: 'Il y a 5 mois',
    comment: 'Faites confiance les yeux fermés c\'est du travail de professionnels ils sont investis et font leur boulot avec respect je recommande vivement',
    source: 'Google',
    avatar: 'https://customer-assets.emergentagent.com/job_concierge-website/artifacts/kk4fvj8t_mata%20rody.png'
  },
  {
    id: 4,
    name: 'Fanny Épée',
    rating: 5,
    date: 'Août 2025',
    timeAgo: 'Il y a 4 mois',
    comment: 'Compétents et amoureux du travail bien fait. L\'ampleur de la tâche ne leur fait pas peur. Je recommande vivement.',
    source: 'Google',
    avatar: 'https://customer-assets.emergentagent.com/job_concierge-website/artifacts/xbh1lni4_fanny%20epee.png'
  },
  {
    id: 5,
    name: 'Alexandra Pedro',
    rating: 5,
    date: 'Juillet 2025',
    timeAgo: 'Il y a 5 mois',
    comment: 'Une team au top ! Ils ont lavé l\'intérieur de ma voiture… et honnêtement, on dirait que je viens de l\'acheter neuve ! Un travail propre, soigné et efficace. Je recommande les yeux fermés !',
    source: 'Google',
    avatar: 'https://customer-assets.emergentagent.com/job_concierge-website/artifacts/aoa8yq9y_alexandra%20pedro.png'
  }
];

export const advantages = [
  {
    id: 1,
    icon: 'Award',
    title: 'Professionnels qualifiés',
    description: 'Nos intervenants sont formés et expérimentés'
  },
  {
    id: 2,
    icon: 'Shield',
    title: '50% de crédit d\'impôt',
    description: 'Bénéficiez de l\'avance immédiate de crédit d\'impôt'
  },
  {
    id: 3,
    icon: 'Clock',
    title: 'Flexibilité totale',
    description: 'Services adaptés à votre emploi du temps'
  },
  {
    id: 4,
    icon: 'ThumbsUp',
    title: 'Satisfaction garantie',
    description: 'Garantie "satisfait ou remboursé"'
  }
];

export const cities = [
  'Méru', 'Beauvais', 'Chambly', "L'Isle-Adam", 'Pontoise', 'Cergy', 
  'Clermont', 'Creil', 'Chantilly', 'Senlis'
];

export const team = [
  {
    id: 1,
    name: 'Christie',
    role: 'Directrice Générale',
    description: 'Christie est en charge de la communication et de l\'information client. Elle veille à ce que nos services, nos engagements et les modalités liées au crédit d\'impôt soient expliqués de manière claire et transparente, notamment à travers notre site internet et nos supports de communication.',
    photo: 'https://customer-assets.emergentagent.com/job_a72f3521-3152-44ec-800d-97dc3c085d7c/artifacts/mlu2qlra_CHRISTIE%20%281%29.png'
  },
  {
    id: 2,
    name: 'Franck',
    role: 'Président',
    description: 'Franck est le fondateur et le référent opérationnel de The MajordHome Conciergerie. Il supervise les interventions, le respect du cadre réglementaire du Service à la Personne et la qualité globale des prestations. Présent sur le terrain, il s\'engage personnellement pour la satisfaction et la confiance de nos clients.',
    photo: 'https://customer-assets.emergentagent.com/job_a72f3521-3152-44ec-800d-97dc3c085d7c/artifacts/avduy08n_FRANCK%20%281%29.png'
  },
  {
    id: 3,
    name: 'Josué',
    role: 'Directeur Général',
    description: 'Josué assure l\'organisation et la coordination des interventions à domicile. Il gère les plannings, le suivi administratif et le budget afin de garantir des prestations fiables, régulières et adaptées aux besoins de chaque client.',
    photo: 'https://customer-assets.emergentagent.com/job_a72f3521-3152-44ec-800d-97dc3c085d7c/artifacts/lm2erv75_JOSUE%20%281%29.png'
  }
];

export const engagements = [
  {
    id: 1,
    icon: 'Shield',
    title: 'Confiance et transparence',
    description: 'Nous nous engageons à établir une relation de confiance avec nos clients, basée sur la transparence, l\'écoute et le respect de nos engagements.'
  },
  {
    id: 2,
    icon: 'Award',
    title: 'Qualité de service',
    description: 'Nos intervenants sont rigoureusement sélectionnés, formés et accompagnés pour garantir des prestations de haute qualité, conformes aux normes du secteur.'
  },
  {
    id: 3,
    icon: 'Users',
    title: 'Respect et bienveillance',
    description: 'Nous accordons une attention particulière au bien-être de nos clients et de nos collaborateurs, dans le respect de la dignité et des valeurs humaines.'
  },
  {
    id: 4,
    icon: 'CheckCircle',
    title: 'Fiabilité et ponctualité',
    description: 'Nous nous engageons à respecter les horaires convenus et à assurer une continuité de service, même en cas d\'imprévu.'
  },
  {
    id: 5,
    icon: 'Heart',
    title: 'Proximité et réactivité',
    description: 'Basés à Méru, nous intervenons dans un rayon de 50 km pour être au plus près de vos besoins et répondre rapidement à vos demandes.'
  },
  {
    id: 6,
    icon: 'Scale',
    title: 'Conformité réglementaire',
    description: 'The MajordHome Conciergerie respecte l\'ensemble des obligations légales et réglementaires du Service à la Personne, notamment en matière de crédit d\'impôt.'
  }
];